// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------

const ar = {
  Hi: "أهلاً",
  Description: "تحتاج مساعدة؟\n يرجى التحقق من مستنداتنا.",
  Documentation: "توثيق",
  EnglishLevel: "مستوى اللغة الإنجليزية",
  FrenchLevel: "المستوى الفرنسي",
  EnglishExam: "امتحان الانجليزية",
  FrenchExam: "امتحان اللغة الفرنسية",
  ExamType: "نوع الامتحان",
  Score: "نتيجة",
  ReadingScore: "نتيجة القراءة",
  WritingScore: "نقاط الكتابة",
  ListeningScore: "نقاط الاستماع",
  SpeakingScore: "نقاط التحدث",
  ExamDate: "موعد الامتحان",
  Yes: "نعم",
  Applicant: "طالب وظيفة",
  Mother: "الأم",
  Father: "أب",
  Brothers: "الإخوة",
  Sisters: "أخوات",
  Children: "أطفال",
  Education: "تعليم",
  Relations: "علاقات",
  Languages: "اللغات",
  Experience: "خبرة",
  Activities: "أنشطة",
  Addresses: "عناوين",
  Travels: "يسافر",
  Passports: "جوازات السفر",
  OtherInformation: "آخر",
  DateofDeath: "تاريخ الوفاة",
  ApplyForVisaCanadaBefore: "هل تقدمت أنت أو أي من أفراد أسرتك للحصول على تأشيرة كندية؟ (سياحي ، سكني ، عمل ، تعليمي ، إلخ)؟",
  VisaCanadaRejectedBefore: "هل سبق لك أو لأي من أفراد أسرتك أن تم رفض طلب تأشيرة لكندا أو لدولة أخرى؟",
  ReportedExperience: "هل تم ترحيلك أو ترحيل أي من أفراد أسرتك من كندا أو أي دولة أخرى؟",
  ModifiedDate: "تاريخ معدل",
  SaveChanges: "حفظ التغييرات",
  OveralExamScore: "نتيجة الامتحان الزائد",
  ExpireDate: "تاريخ انتهاء الصلاحية",
  SelectYourLevel: "حدد مستواك",
  DidYouHaveExam: "هل لديك امتحان؟",
  WitchExam: "امتحان الساحرة؟",
  SelectLanguage: "اختار اللغة",
  AsylumApplied: "هل تقدمت أنت أو أي من أفراد أسرتك من قبل بطلب لجوء في كندا أو أي دولة أخرى؟",
  ArrestedBefore: "هل ارتكبت أنت أو أي من أفراد أسرتك جريمة أو تم القبض عليك؟",
  HealthCareBefore: "بالإضافة إلى تناول الأدوية ، هل تحتاج أنت أو أي من أفراد أسرتك إلى مساعدة من مقدمي الرعاية الصحية أثناء وجودك في كندا؟",
  StayLongerThanVisa: "هل لديك أنت أو أحد أفراد أسرتك أي خبرة في البقاء في كندا أو بلد آخر لفترة أطول من صلاحية تأشيرتك؟",
  TerroristHistory: "هل لديك أنت أو أي فرد من أفراد أسرتك تاريخ من التورط مع الجماعات السياسية أو الجماعات الإرهابية ، وما إلى ذلك",
  SecurityProblems:
    "يرجى التوضيح بشكل كامل ما إذا كنت أنت أو أي فرد من أفراد عائلتك لديه أي تاريخ من الممارسات الخاطئة أو المشاكل الأمنية أو الإجراءات السابقة المتعلقة بالتأشيرة من كندا أو أي دولة أخرى.",
  No: "رقم",
  Expert: "خبير",
  VeryGood: "حسن جدا",
  Good: "جيد",
  Competent: "كفؤ",
  Modest: "محتشم",
  Limited: "محدود",
  None: "لا أحد",
  IELTSGeneral: "IELTS عام",
  IELTSAcademic: "IELTS Academic",
  CELPIPG: "سيلبيب جي",
  TEF: "TEF",
  CELPIP: "سيلبيب",
  Gender: "جنس",
  FirstName: "الاسم الاول",
  LastName: "الكنية",
  FirstNameNativeLanguage: "الاسم الأول (اللغة الأم)",
  LastNameNativeLanguage: "الاسم الأخير (اللغة الأصلية)",
  FirstNameEnglish: "الاسم الاول (انجليزي)",
  LastNameEnglish: "اسم العائلة (انجليزي)",
  DateofBirth: "تاريخ الميلاد",
  Height: "ارتفاع",
  EyeColor: "لون العين",
  CityofBirth: "مدينة الولادة",
  CountryofBirth: "بلد الميلاد",
  DeathDate: "تاريخ الوفاة",
  CityofDeath: "مدينة الموت",
  CountryofDeath: "بلد الموت",
  PostalCode: "رمز بريدي",
  JobTitle: "مسمى وظيفي",
  Company: "شركة",
  Email: "البريد الإلكتروني",
  MaritalStatus: "الحالة الحالة الإجتماعية",
  ChildNumber: "رقم الطفل",
  DateofMarriage: "تاريخ الزواج",
  DateofDivorce: "تاريخ الطلاق",
  Address: "تبوك",
  NetWorth: "صافي القيمة",
  EducationLevel: "مستوى التعليم",
  EducationMajor: "تخصص تعليمي",
  MoreAboutEducation: "المزيد عن التعليم",
  WorkExperince: "خبرة في العمل",
  WorkType: "نوع العمل",
  MoreAboutWork: "المزيد عن العمل",
  PleaseExplainAboutYourEducationHistory: "يرجى شرح تاريخ التعليم الخاص بك",
  PleaseExplainAboutYourJobHistory: "يرجى توضيح تاريخ وظيفتك",
  General: "عام",
  Profile: "الملف الشخصي",
  AssessmentForm: "استمارة التقييم",
  SocialLinks: "روابط اجتماعية",
  ChangePassword: "غير كلمة السر",
  AccountSettings: "إعدادت الحساب",
  Account: "الحساب",
  ClientsEvaluated: "تقييم العملاء",
  ImmigrationCases: "قضايا الهجرة",
  TotalPosts: "إجمالي المشاركات",
  About: "حول",
  LiveAt: "يعيش في نبسب",
  YouAreAssessed: "سيقيم معلوماتك",
  AssessingYou: "تقييمك",
  AssessMe: "قيمني",
  HasAccessDocuments: "لديه حق الوصول إلى المستندات الخاصة بك",
  DisconnectAccess: "قطع الوصول",
  DocumentAccess: "الوصول إلى المستند",
  Password: "كلمة المرور",
  App: "تطبيق",
  user: "المستعمل",
  List: "قائمة",
  Edit: "يحرر",
  Shop: "محل",
  Blog: "مقالات",
  Mail: "بريد",
  Chat: "دردشة",
  Cards: "البطاقات",
  Posts: "المشاركات",
  Create: "خلق",
  Banking: "الخدمات المصرفية",
  Booking: "الحجز",
  Product: "منتج",
  Invoice: "فاتورة",
  Details: "تفاصيل",
  Checkout: "الدفع",
  Calendar: "تقويم",
  Analytics: "تحليلات",
  Ecommerce: "التجارة الإلكترونية",
  Management: "ادارة الحساب",
  Menu: "قائمة الطعام",
  Item_disabled: "تم تعطيل العنصر",
  Item_label: "تسمية العنصر",
  Item_caption: "شرح العنصر",
  Other_cases: "حالات اخرى",
  Item_by_roles: "عنصر حسب الأدوار",
  Only_admin_can_see_this_item: "يمكن للمسؤول فقط رؤية هذا العنصر",
  TotalElementarySchool: "مجموع سنوات الدراسة الابتدائية",
  TotalMiddleSchool: "مجموع سنوات التعليم المتوسط",
  TotalHighSchool: "مجموع سنوات التعليم الثانوي",
  TotalPreUniversity: "مجموع سنوات التعليم قبل الجامعي",
  TotalAssociate: "مجموع السنوات الأكاديمية لدرجة الزمالة",
  TotalUndergraduate: "مجموع سنوات الدراسة الجامعية",
  TotalMaster: "مجموع سنوات الدراسة لدرجة الماجستير",
  TotalDoctoral: "مجموع سنوات دراسات الدكتوراه",
  TotalProfessional: "مجموع السنوات الأكاديمية الفنية والمهنية",
  Organization: "منظمة",
  Degree: "درجة",
  Major: "رئيسي",
  SelectType: "اختر صنف",
  StartDate: "تاريخ البدء",
  EndDate: "تاريخ الانتهاء",
  City: "مدينة",
  Country: "دولة",
  Relation: "علاقة",
  CityofResidence: "مدينة الإقامة",
  ProvinceofResidence: "مقاطعة الإقامة",
  ActivityType: "نوع النشاط",
  ActivityLocation: "موقع النشاط",
  License: "رخصة",
  MoreInformation: "معلومات اكثر",
  PassportNumber: "رقم جواز السفر",
  IssueDate: "تاريخ الإصدار",
  ExpiryDate: "تاريخ انتهاء الصلاحية",
  DayPerWeek: "يوم في الأسبوع",
  HourPerDay: "ساعة في اليوم",
  CompanyPhone: "هاتف الشركة",
  CEOName: "اسم الرئيس التنفيذي",
  CEOPhoneNumber: "رقم هاتف الرئيس التنفيذي",
  YourManagerName: "اسم مديرك",
  YourManagerTitle: "لقب مديرك",
  YourManagerPhoneNumber: "رقم هاتف مديرك",
  CompanyPostalCode: "الرمز البريدي للشركة",
  ActivityLocationHelper: "",
  FullTime: "وقت كامل",
  PartTime: "دوام جزئى",
  Citizen: "مواطن",
  PermanentResidence: "إقامة دائمة",
  TemporaryResidence: "إقامة مؤقتة",
  StatusinCanada: "الوضع في كندا",
  Spouse: "زوج",
  Background: "خلفية",
  Documents: "وثائق",
  Questioner: "استبيان",
  Personal: "شخصي",
  PersonalPhoto: "",
  InformationAboutPersonalPhoto: "معلومات عن الصورة الشخصية",
  UploadFile: "رفع ملف",
  PrintTime: "وقت الطباعة",
  TranslationDateIfTranslated: "تاريخ الترجمة (إذا تمت ترجمته)",
  NationalID: "الهوية الوطنية",
  MilitaryServiceLicense: "رخصة الخدمة العسكرية",
  PhotocopyMarriageCertificate: "نسخة من رخصة / شهادة الزواج",
  IDCard: "بطاقة التعريف",
  PhotocopyDivorceDocuments: "صورة من وثائق الطلاق",
  NumberofChildren: "عدد الاطفال",
  Consultants: "استشاريون",
  MyAccount: "حسابي",
  consultant: "مستشار",
  applicant: "طالب وظيفة",
  ShareWhatThinkingAbout: "شارك بما تفكر فيه",
  Post: "بريد",
  Logout: "تسجيل خروج",
  Home: "مسكن",
  Beta: "بيتا",
  SignUp: "اشتراك",
  Dashboard: "لوحة القيادة",
  Pages: "الصفحات",
  Other: "آخر",
  AboutUs: "معلومات عنا",
  ContactUs: "اتصل بنا",
  Pricing: "التسعير",
  Login: "تسجيل الدخول",
  Register: "يسجل",
  ResetPassword: "إعادة تعيين كلمة المرور",
  WriteComment: "أكتب تعليقا…",
  Authentication: "المصادقة",
  SortBy: "صنف حسب",
  Name: "اسم",
  Applicants: "المتقدمون",
  Immigrationfromhereto: "الهجرة من هنا إلى",
  Canada: "كندا",
  BetterProbroadimmigrationplatform: "BetterPro هي عبارة عن منصة واسعة للهجرة تسمح للمهاجرين والمستشارين بالعثور على بعضهم البعض والبقاء على اتصال",
  GetStarted: "البدء",
  HowBetterProHelpYou: "كيف يساعدك BetterPro؟",
  ServicesForConsultants: "خدمات خاصة للاستشاريين",
  Questionnaire: "استبيان",
  CollectInformationAboutClients: "اجمع معلومات عن العملاء ، مثل معلوماتهم الشخصية ، وعملهم ، وتعليمهم ، وما إلى ذلك ، واستكمل نماذج الهجرة بهذه المعلومات",
  CollectingDocuments: "جمع المستندات",
  GatherDocumentsfromApplicants: "جمع المستندات من المتقدمين بطريقة مصنفة وفقًا لاحتياجات كل حالة هجرة.",
  SafeCommunication: "اتصال آمن",
  ConsultantsApplicantsCommunicate: "يمكن لمستشاري الهجرة والمتقدمين التواصل عبر BetterPro في جميع مراحل عملية الهجرة (من التقييم الأولي إلى الحصول على تأشيرة",
  ProfilePage: "الصفحة الشخصية",
  HavinguptodateProfiles: "سيساعدك امتلاك ملفات تعريف محدثة بلغات متعددة على جذب المزيد من العملاء",
  PlansCustomized: "الخطط التي يمكن تخصيصها",
  ToMeetYourNeeds: "لتلبية احتياجات شركتك",
  MakeModernOnline: "اجعل عملك الحديث عبر الإنترنت ناجحًا باختيار خطة",
  PlusTaxes: " * بالإضافة إلى الضرائب المطبقة",
  mo: "/ شهر",
  POPULAR: "جمع",
  Basic: "أساسي",
  ThirtyDaysTrial: "30 يومًا للتجربة / لا يلزم وجود بطاقة ائتمان",
  SixtyDaysTrial: "60 يومًا للتجربة / لا يلزم وجود بطاقة ائتمان",
  NinetyDaysTrial: "90 يومًا للتجربة / لا يلزم وجود بطاقة ائتمان",
  MultilanguageProfile: "ملف تعريف متعدد اللغات",
  Blogging: "التدوين",
  AccessToLeads: "الوصول إلى العملاء المحتملين",
  ComminicateWithClients: "تعاون مع العملاء",
  FullSupport: "دعم كامل",
  Starter: "بداية",
  Premium: "الممتازة",
  ChoosePremium: "اختر بريميوم",
  ChooseStarter: "اختر كاتب",
  ChooseBasic: "اختر أساسي",
  GetStartedWith: "ابدأ مع",
  BetterProPlatformToday: "منصة BetterPro اليوم",
  WhereFindUs: "أين تجدنا؟",
  FeelFreeContactUs: "لا تتردد في الاتصال بنا.",
  WeGladHearFromYou: "سنكون سعداء أن نسمع منك.",
  ToShareYourComment: "للمشاركة بتعليقك حول",
  PleaseSignup: "يرجى الاشتراك",
  IAmConsultant: "أنا مستشار / محامي هجرة",
  IAmImmigrate: "أنوي الهجرة إلى كندا",
  SelectBestOption: "حدد الخيار الأفضل",
  AlreadyHaveAccount: "هل لديك حساب؟",
  BroadImmigrationPlatformBetterPro: "منصة هجرة واسعة مع BetterPro",
  GetStartedFree: "ابدأ مجانًا تمامًا.",
  NoCreditNeeded: "لا حاجة لبطاقة ائتمان.",
  DontHaveAccount: "ليس لديك حساب؟",
  EnterDetails: "أدخل التفاصيل الخاصة بك أدناه.",
  WelcomeBack: "مرحبا ، مرحبا بعودتك",
  RememberMe: "تذكرنى",
  ForgotPassword: "هل نسيت كلمة السر؟",

  FieldofStudy: "Field of Study",
  TypeofWork: "Type of Work",
  AnnulledMarriage: "Annulled Marriage",
  CommonLaw: "Common-Law",
  DivorcedSeparated: "Divorced / Separated",
  LegallySeparated: "Legally Separated",
  Married: "Married",
  NeverMarriedSingle: "Never Married / Single",
  Widowed: "Widowed",
  RegisterSaveInformation: "سجل لحفظ المعلومات واستقبال رسائل استشاري",
  AssessmentForm: "َAssessment Form",
  UserName: "User Name",
  BlogPosts: "Blog Posts",
  NotProfileLanguage: "Consultant does not have a profile for this language. Please select another language.",
  Services: "Services",
  ContactInfo: "Contact Info (Please let the consultant know how best to contact you)",
  PhoneNumber: "Phone Number",
};

export default ar;
